var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdateData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 9.18259L10.2576 7L8.51501 9.18259H9.7555C9.73956 9.35273 9.70241 9.52079 9.64493 9.68386C9.2913 10.6803 8.26536 11.1751 7.35714 10.7872L7 11.7942C7.32702 11.9337 7.66339 12 7.99509 12C9.09664 12 10.139 11.2682 10.5624 10.0758C10.6646 9.78627 10.7247 9.48547 10.7434 9.18259H12Z",
    fill: "#309EA7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.89504 6.25695C6.22224 6.58136 5.70503 7.1737 5.43845 7.92503C5.33668 8.2119 5.27687 8.51368 5.25815 8.81771H4L5.74232 11L7.48448 8.81771H6.24417C6.2607 8.64813 6.29784 8.48031 6.35575 8.31666C6.52683 7.83438 6.85906 7.45382 7.29117 7.24557C7.72328 7.037 8.20349 7.02561 8.64306 7.21365L9 6.20721C8.3155 5.91473 7.56784 5.93238 6.89504 6.25695Z",
    fill: "#309EA7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.41421 1C6.149 1 5.89464 1.10536 5.70711 1.29289L2.29289 4.70711C2.10536 4.89464 2 5.149 2 5.41421L2 14C2 14.5523 2.44772 15 3 15H13C13.5523 15 14 14.5523 14 14V2C14 1.44772 13.5523 1 13 1L6.41421 1ZM5.91207 2.82185C6.0394 2.70058 6.25 2.79084 6.25 2.96668V4.91915C6.25 5.02961 6.16046 5.11915 6.05 5.11915H3.99999C3.81945 5.11915 3.73132 4.89884 3.86205 4.77433L5.91207 2.82185ZM12.5 13C12.5 13.2761 12.2761 13.5 12 13.5H4C3.72386 13.5 3.5 13.2761 3.5 13V9.80958V6.5C3.5 6.22386 3.72386 6 4 6H6.5C6.77614 6 7 5.77614 7 5.5V3C7 2.72386 7.22386 2.5 7.5 2.5H12C12.2761 2.5 12.5 2.72386 12.5 3V13Z",
    fill: "#309EA7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateData);
export default __webpack_public_path__ + "static/media/updateData.06de953fa296af4035bfc9da902447ff.svg";
export { ForwardRef as ReactComponent };